import CircularProgress from './CircularProgress';
export default CircularProgress;
//# sourceMappingURL=index.js.map